import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { UsageToegangService } from '../services/usage-toegang.service';

/** De pagina Usage: de clubbeheerder, of iemand met het vinkje "Can see usage". */
export const usageGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(UsageToegangService).magZien().pipe(map(mag => mag || router.parseUrl('/')));
};
